import { Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import LevelTestBox from '../../components/user/LevelTestBox'
import Test from '../../components/user/Test'

const LevelTest = () => {
  const [opened, { open, close }] = useDisclosure(false)

  const mockData = [
    {
      id: 1,
      text: '7×9의 값을 고르세요.',
      options: [
        { id: 1, text: '56' },
        { id: 2, text: '60' },
        { id: 3, text: '63' },
        { id: 4, text: '66' },
        { id: 5, text: '70' },
      ],
    },
    {
      id: 2,
      text: '□+△+○의 값을 구하세요.',
      additionalText: '4×6=□, 3×7=△, 8×7=○',
      options: [
        { id: 1, text: '101' },
        { id: 2, text: '102' },
        { id: 3, text: '103' },
        { id: 4, text: '104' },
        { id: 5, text: '105' },
      ],
    },
    {
      id: 3,
      text: '원의 넓이 합을 구하세요.',
      options: [
        { id: 1, text: '15' },
        { id: 2, text: '20' },
        { id: 3, text: '30' },
        { id: 4, text: '40' },
        { id: 5, text: '25' },
      ],
    },
    {
      id: 4,
      text: '원의 넓이 합을 구하세요.',
      options: [
        { id: 1, text: '15' },
        { id: 2, text: '20' },
        { id: 3, text: '30' },
        { id: 4, text: '40' },
        { id: 5, text: '25' },
      ],
    },
    {
      id: 5,
      text: '원의 넓이 합을 구하세요.',
      imageUrl:
        'https://www.mathwarehouse.com/geometry/circle/images/area/area-of-a-circle-formula.png',
      options: [
        { id: 1, text: '15' },
        { id: 2, text: '20' },
        { id: 3, text: '30' },
        { id: 4, text: '40' },
        { id: 5, text: '25' },
      ],
    },
  ]

  const handleSubmit = (answers: Record<number, number>) => {
    open()
  }

  return (
    <>
      <LevelTestBox
        content={<Test questions={mockData} onSubmit={handleSubmit} />}
        layout="tertiary"
      />
      <Modal opened={opened} onClose={close} withCloseButton={true} centered>
        <img src="/assets/icons/check.png" alt="check" style={{ width: 18, height: 18, objectFit: 'contain', verticalAlign: 'middle', marginRight: 6 }} />Submission complete
      </Modal>
    </>
  )
}

export default LevelTest
